import { Pipe } from '@angular/core';
import { shuffle } from '../utils/utils';
var ShufflePipe = (function () {
    function ShufflePipe() {
    }
    ShufflePipe.prototype.transform = function (input) {
        return shuffle(input);
    };
    return ShufflePipe;
}());
export { ShufflePipe };
ShufflePipe.decorators = [
    { type: Pipe, args: [{
                name: 'shuffle'
            },] },
];
/** @nocollapse */
ShufflePipe.ctorParameters = function () { return []; };
//# sourceMappingURL=shuffle.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/array/shuffle.pipe.js
// module id = 246
// module chunks = 103